"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StovesHousesNamibiaCreationRequest = void 0;
const stovesHousesNamibiaConstants_1 = require("../constants/stovesHousesNamibiaConstants");
class StovesHousesNamibiaCreationRequest {
    constructor() {
        this.stovesHousesNamibiaConstants = new stovesHousesNamibiaConstants_1.StovesHousesNamibiaConstants();
    }
}
exports.StovesHousesNamibiaCreationRequest = StovesHousesNamibiaCreationRequest;
